import { destroy2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RestaurantTable } from "@/shared/utils/interfaces";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const useRestaurantTableDelete = (restaurantId: number) => {
  const queryClient = useQueryClient();
  const branchId = useBranchId();
  const mutation = useMutation({
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ["restaurantMap", branchId, restaurantId],
        exact: true,
      });
    },
    mutationFn: (table: RestaurantTable) =>
      destroy2(
        `/internal/secure/pos/v1/tables/${branchId}/${restaurantId}/${table.item_id}`
      ),
  });
  return mutation;
};

export default useRestaurantTableDelete;
